import 'css-chunksrc/client/pages/obsPage/tree/node/styles.scss';export default {
  "node": "_node_1phe2_1",
  "rowWrapper": "_rowWrapper_1phe2_5",
  "icon": "_icon_1phe2_8",
  "addAction": "_addAction_1phe2_11",
  "contextualMenu": "_contextualMenu_1phe2_15",
  "row": "_row_1phe2_5",
  "depth0": "_depth0_1phe2_38",
  "nameCell": "_nameCell_1phe2_44",
  "depth1": "_depth1_1phe2_48",
  "depth2": "_depth2_1phe2_58",
  "depth3": "_depth3_1phe2_68",
  "depth4": "_depth4_1phe2_78",
  "depth5": "_depth5_1phe2_88",
  "depth6": "_depth6_1phe2_98",
  "depth7": "_depth7_1phe2_108",
  "depth8": "_depth8_1phe2_118",
  "depth9": "_depth9_1phe2_128",
  "depth10": "_depth10_1phe2_138",
  "depth11": "_depth11_1phe2_148",
  "depth12": "_depth12_1phe2_158",
  "depth13": "_depth13_1phe2_168",
  "depth14": "_depth14_1phe2_178",
  "depth15": "_depth15_1phe2_188",
  "depth16": "_depth16_1phe2_198",
  "depth17": "_depth17_1phe2_208",
  "depth18": "_depth18_1phe2_218",
  "depth19": "_depth19_1phe2_228",
  "depth20": "_depth20_1phe2_238",
  "passThrough": "_passThrough_1phe2_248",
  "dragging": "_dragging_1phe2_259",
  "toggleArrowBox": "_toggleArrowBox_1phe2_264",
  "nameContainer": "_nameContainer_1phe2_273",
  "name": "_name_1phe2_44",
  "clickable": "_clickable_1phe2_287",
  "resourcesCount": "_resourcesCount_1phe2_294",
  "editForm": "_editForm_1phe2_302",
  "editInput": "_editInput_1phe2_306",
  "editButton": "_editButton_1phe2_311",
  "addLine": "_addLine_1phe2_360",
  "addBubble": "_addBubble_1phe2_370",
  "addIcon": "_addIcon_1phe2_391",
  "children": "_children_1phe2_398",
  "stacked": "_stacked_1phe2_403"
};